import BookingDetails from "modules/Admin/orders/BookingDetails"

function BookingDetailsPage() {
    return (
        <div data-testid="adminBookingDetailsPage">
            <BookingDetails />
        </div>
    )
}

export default BookingDetailsPage